export const OfferBadge = ({ offer, testId, className = "" }) => (
  <span data-testid={testId}
    className={`inline-flex items-center whitespace-nowrap rounded-full border-2 border-white bg-[#F0303A] px-2.5 py-1 text-[13px] font-extrabold text-white shadow-[0_3px_0_rgba(0,0,0,0.18)] ${className}`}>
    {offer.badge}
  </span>
);

export const OfferNote = ({ offer, testId }) => (
  <p data-testid={testId} className="mt-1 text-sm font-bold text-[#F0303A]">{offer.note}</p>
);
